import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RouterState } from './router-serializer';

export const selectRouterState = createFeatureSelector<RouterState>('router');
export const selectRouterParams = createSelector(selectRouterState, (router) => router?.state.params);
export const selectRouterData = createSelector(selectRouterState, (router) => router?.state.data);
export const selectRouterUrl = createSelector(selectRouterState, (router) => router?.state.url);
